<template>
  <div class="head">
    <div class="box">
      <router-link exact to="/" tag="div">
        <!-- <img src="../assets/logo2.png" alt="" /> -->
        <img src="../assets/aotuo/logo.png" alt="" />
      </router-link>
      <ul>
        <li>
          <router-link tag="div" to="/"> 会社概要 </router-link>
        </li>
        <li>
          <router-link tag="div" to="/ggtf"> 弊社の強み </router-link>
        </li>
        <li>
          <router-link tag="div" to="/ftf"> 製品一覧 </router-link>
        </li>
        <li @click="loginDialog" class="activeLi">
          <router-link tag="div" to=""> {{ routerUsername }} </router-link>
          <div class="exit" v-show="routerUsername != 'ログイン'" @click.stop="loginOut">
            退出登录
          </div>
        </li>
      </ul>
    </div>
    <el-dialog
      center
      :title="title"
      :visible.sync="dialogFormVisible"
      width="30%"
    >
      <div v-show="formLogin">
        <!-- 登录表单 -->
        <el-form :model="form" :rules="rules" ref="form" label-width="0px">
          <!-- <el-form-item label="" prop="email">
            <el-input
              v-model="form.email"
              autocomplete="off"
              placeholder="邮箱"
            ></el-input>
          </el-form-item> -->
          <el-form-item label="" prop="username">
            <el-input
              v-model="form.username"
              autocomplete="off"
              placeholder="ユーザー名"
            ></el-input>
          </el-form-item>
          <el-form-item label="" prop="password">
            <el-input
              v-model="form.password"
              autocomplete="off"
              placeholder="パスワード"
            ></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="submitForm('form')"
            >登 録</el-button
          >
          <div class="registerBox" @click="gotoRegister">
            アカウントがありません,すぐ登録します
          </div>
        </div>
      </div>
      <div v-show="formRegister">
        <!-- 注册表单 -->
        <el-form
          :model="ruleForm"
          :rules="rulesRegister"
          ref="ruleForm"
          label-width="0px"
        >
          <el-form-item label="" prop="username">
            <el-input
              v-model="ruleForm.username"
              autocomplete="off"
              placeholder="ユーザー名"
            ></el-input>
          </el-form-item>
          <el-form-item label="" prop="email">
            <el-input
              v-model="ruleForm.email"
              autocomplete="off"
              placeholder="Email"
            ></el-input>
          </el-form-item>
          <el-form-item label="" prop="password">
            <el-input
              v-model="ruleForm.password"
              autocomplete="off"
              placeholder="パスワード"
            ></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="submitRuleform('ruleForm')"
            >登 録</el-button
          >
          <div class="registerBox" @click="gotoLogin">ログイン</div>
        </div>
      </div>
    </el-dialog>
    <el-dialog title="ヒント" :visible.sync="tip" width="30%">
      <span>{{ message }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="tipRegister">確 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { loginYuri, registerYuri } from '../api/index'
export default {
  name: 'Head',
  components: {},
  data() {
    return {
      launage: '',
      routerUsername: 'ログイン',
      message: '',
      tip: false,
      title: 'アカウントログイン',//账户登录
      dialogFormVisible: false, //登录弹窗
      formRegister: false, //注册表单
      formLogin: false, //注册表单
      form: {
        username: '',
        password: '',
      },
      rules: {
        username: [
          { required: true, message: '入力してください', trigger: 'blur' },
        ],
        password: {
          required: true,
          message: '入力してください',
          trigger: 'blur',
        },
      },
      ruleForm: {
        username: '',
        email: '',
        password: '',
      },
      rulesRegister: {
        username: [
          { required: true, message: '入力してください', trigger: 'blur' },
        ],
        email: [
          { required: true, message: '入力してください', trigger: 'blur' },
          {
            type: 'email',
            message: 'フォーマットエラー',
            trigger: ['blur', 'change'],
          },
        ],
        password: {
          required: true,
          message: '入力してください',
          trigger: 'blur',
        },
      },
    }
  },
  created() {},
  mounted() {
    this.routerUsername = sessionStorage.getItem('routerUsername')
      ? sessionStorage.getItem('routerUsername')
      : this.routerUsername
  },
  computed: {},
  methods: {
    //退出登录
    loginOut(){
      this.dialogFormVisible = false
      this.routerUsername='ログイン'
      sessionStorage.clear()
      this.form.username = ''
      this.form.password = ''

    },
    //登录按钮
    loginDialog() {
      if (this.routerUsername == 'ログイン') {
        this.dialogFormVisible = true
        this.formLogin = true
        this.formRegister = false
      }
    },
    //去注册
    gotoRegister() {
      this.formRegister = true
      this.formLogin = false
      this.title = 'アカウント登録'
      this.form.username = ''
      this.form.password = ''
    },
    //去登录
    gotoLogin() {
      this.formRegister = false
      this.formLogin = true
      this.title = '账户登录'
      this.ruleForm.username = ''
      this.ruleForm.email = ''
      this.ruleForm.password = ''
    },
    //登录接口
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          loginYuri(this.form).then((res) => {
            if (res.code == 200) {
              this.dialogFormVisible = false
              this.routerUsername = res.data
              sessionStorage.setItem('routerUsername', res.data)
              this.$message({
                message: 'ログインできました',
                type: 'success',
                center: true,
              })
            } else {
              this.tip = true
              this.message = res.msg
            }
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    //注册接口
    submitRuleform(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          registerYuri(this.ruleForm).then((res) => {
            if (res.code == 200) {
              this.dialogFormVisible = false
              this.routerUsername = res.data
              sessionStorage.setItem('routerUsername', res.data) //以“key”为名称存储一个值“value”
              this.$message({
                message: '登録できました',
                type: 'success',
                center: true,
              })
            } else {
              this.$message({
                message: res.msg,
                center: true,
              })
            }
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    //提示未注册去注册
    tipRegister() {
      this.tip = false
      this.formRegister = true
      this.formLogin = false
      this.title = 'アカウント登録'
    },    
  },
}
</script>
<style lang="less" scoped>
.head {
  width: 100%;
  height: 60px;
  // background: #fa9600;
  margin-bottom: 16px;
}
.box {
  width: 1200px;
  height: 60px;
  line-height: 60px;
  margin: auto;
  display: flex;
  justify-content: space-between;
  img {
    height: 60px;
    cursor: pointer;
  }
  ul {
    display: flex;
    li {
      margin-left: 126px;
      color: #999999;
      cursor: pointer;
    }
    .activeLi{
      position: relative;
    }
  .exit{
    width: 76px;
    display: none;
    position: absolute;
    text-align: center;
    left: -14px;
    font-size: 14px;
  }
    .activeLi:hover .exit {
      background: rgba(245,245,245);
      display: block;
    }
  }
}
.el-button--primary {
  color: #fff;
  background-color: #409eff;
  border-color: #409eff;
  width: 100%;
}
/deep/.el-dialog--center .el-dialog__body {
  text-align: initial;
  padding: 25px 25px 30px;
}
.registerBox {
  color: #409eff;
  margin-top: 10px;
  margin-left: 0;
  cursor: pointer;
}
</style>
